module.exports = __webpack_public_path__ + "static/media/logo-whatsapp.8b47f833.svg";